import { cn } from "@omni/utils/styles";
import { ReactNode, useState } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { getTranslatedFacetName } from "@/utils/search/facetTranslation.utils";

type SearchRefinementListComponentProps = {
    facetName: string;
    children?: ReactNode;
};

const FacetComponent = ({
    facetName,
    children
}: SearchRefinementListComponentProps) => {
    const [collapsed, setCollapsed] = useState(false);

    const { t } = useGranite();
    const translatedFacetName = getTranslatedFacetName(facetName, t);

    const handleOnLabelClick = () =>
        setCollapsed((isCollapsed) => !isCollapsed);

    return (
        <div
            className={cn(
                "tw:w-full",
                "tw:not-first:pt-5 tw:not-first:mt-5 tw:not-first:border-t tw:not-first:border-divider"
            )}
        >
            <h3
                className={cn(
                    "tw:flex tw:justify-between tw:cursor-pointer tw:items-center tw:my-0"
                )}
                onClick={handleOnLabelClick}
            >
                {translatedFacetName}
                <i
                    className={cn(
                        "las la-angle-down",
                        "tw:ml-1 tw:rotate-z-180 tw:transition-transform tw:origin-center",
                        {
                            "tw:rotate-z-0": collapsed
                        }
                    )}
                />
            </h3>
            <div
                className={cn(
                    "tw:grid tw:grid-rows-[1fr] tw:transition-all tw:position-relative",
                    {
                        "tw:grid-rows-[0fr] tw:opacity-0": collapsed,
                        "tw:pt-3": !collapsed
                    }
                )}
            >
                <div
                    className={cn(
                        "tw:overflow-hidden",
                        "tw:[&>ul]:leading-7.5 tw:[&>button]:leading-7.5",
                        "tw:sm:[&>ul]:leading-6.5 tw:sm:[&>button]:leading-6.5"
                    )}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export { FacetComponent };
